import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button, { Themes } from 'ui/Button/Button';
import { ContactUsModal } from 'components/modals';
import routePaths from 'routes/routePaths';

import styles from './Support.module.css';

import complaint from 'assets/icons/complaints.png';
import support from 'assets/icons/support.png';
import question from 'assets/icons/question.png';

const Support = () => {
  const [isContactsModalOpen, setContactsModalOpen] = useState(false);
  const toggleContactsModalOpen = () => setContactsModalOpen((prevOpen) => !prevOpen);

  const history = useHistory();
  const goToFAQ = () => history.push(routePaths.faq);
  const goToComplaint = () => history.push(routePaths.complaint);

  return (
    <div className={styles.wrapper}>
      <Button
        theme={Themes.secondary}
        className={styles.button}
        onClick={goToFAQ}
      >
        <img src={question} alt="faq" className={styles.icon} />
        FAQs
      </Button>
      <Button
        onClick={toggleContactsModalOpen}
        theme={Themes.secondary}
        className={styles.button}
      >
        <img src={support} alt="contact us" className={styles.icon} />
        Contact Us
      </Button>
      <Button
        onClick={goToComplaint}
        theme={Themes.secondary}
        className={styles.button}
      >
        <img src={complaint} alt="complaint" className={styles.icon} />
        Complaint
      </Button>
      <ContactUsModal open={isContactsModalOpen} onClose={toggleContactsModalOpen} />
    </div>
  );
};

export default Support;
